import {createAction} from "@reduxjs/toolkit";
import {DONE, FAIL, FETCH, ARTICLES, AUTHORS, REGIONS, KINDERGARTENS, THEME_LIST, ARTICLE_LIST, AUTORS_LIST} from "../../constants"

export const fetchArticlesAction = createAction<undefined>(ARTICLES + FETCH)
export const fetchArticlesActionDone = createAction<undefined>(ARTICLES + FETCH + DONE)
export const fetchArticlesActionFail = createAction<undefined>(ARTICLES + FETCH + FAIL)

export const fetchAuthorsAction = createAction<undefined>(AUTHORS + FETCH)
export const fetchAuthorsActionDone = createAction<undefined>(AUTHORS + FETCH + DONE)
export const fetchAuthorsActionFail = createAction<undefined>(AUTHORS + FETCH + FAIL)

export const fetchRegionsAction = createAction<undefined>(REGIONS + FETCH)
export const fetchRegionsActionDone = createAction<undefined>(REGIONS + FETCH + DONE)
export const fetchRegionsActionFail = createAction<undefined>(REGIONS + FETCH + FAIL)

export const fetchKindergartensAction = createAction<any>(KINDERGARTENS + FETCH)
export const fetchKindergartensActionDone = createAction<any>(KINDERGARTENS + FETCH + DONE)
export const fetchKindergartensActionFail = createAction<undefined>(KINDERGARTENS + FETCH + FAIL)

export const fetchThemeListAction = createAction<any>(THEME_LIST + FETCH)
export const fetchThemeListDone = createAction<any>(THEME_LIST + FETCH + DONE)
export const fetchThemeListFail = createAction<any>(THEME_LIST + FETCH + FAIL)

export const fetchArticleListAction = createAction<any>(ARTICLE_LIST + FETCH);
export const fetchArticleListDone = createAction<any>(ARTICLE_LIST + FETCH + DONE);
export const fetchArticleListFail = createAction<any>(ARTICLE_LIST + FETCH + FAIL);

export const fetchAutorsListAction = createAction<any>(AUTORS_LIST + FETCH);
export const fetchAutorsListDone = createAction<any>(AUTORS_LIST + FETCH + DONE);
export const fetchAutorsListFail = createAction<any>(AUTORS_LIST + FETCH + FAIL);